import React, { use, useEffect, useState } from "react";
import { CompanyTenK } from "../../company";
import { getTenK } from "../../api";
import TenKFinderItem from "./TenKFinderItem/TenKFinderItem";

interface Props {
  ticker: string;
}

const TenKFinder = ({ ticker }: Props) => {
  const [companyData, setCompanyData] = React.useState<CompanyTenK[]>();
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const fetchTenKData = async () => {
      try {
        const response = await getTenK(ticker);
        setCompanyData(response?.data);
      } catch (err: any) {
        setError(err.message || "Something went wrong while fetching data.");
      }
    };
    fetchTenKData();
  }, [ticker]);

  if (error) {
    return <div className="text-red-600 font-medium">⚠️ Error fetching data: {error}</div>;
  }

  return (
    <>
      <div
        className="inline-flex rounded-md shadow-black/50 shadow-lg m-4 
                transition-transform duration-200 hover:scale-105"
      >
        {companyData ? (
          companyData?.map((tenK) => {
            return <TenKFinderItem tenK={tenK} />;
          })
        ) : (
          <>
            <div className="text-gray-500">No data available.</div>
          </>
        )}
      </div>
    </>
  );
};

export default TenKFinder;
